import clsxm from "immigram-ui-cmon/src/lib/clsxm";
import Skeleton from "react-loading-skeleton";

export function ImmigramFormSkeleton({ className }: { className?: string }) {
  return (
    <div className={clsxm("flex flex-col gap-4", className)}>
      <Skeleton containerClassName="mb-2" height={56} />
      <Skeleton height={28} width={300} />
      <Skeleton containerClassName="mb-2" height={56} />
      <Skeleton height={28} width={350} />
      <Skeleton containerClassName="mb-2" height={56} />
      <Skeleton height={28} width={250} />
      <Skeleton
        containerClassName="flex flex-col gap-4"
        height={94}
        count={3}
        inline
      />
    </div>
  );
}
